import React from "react";
import { useGetUserStreaks } from "../../Controllers/DashboardController";
import DoughnutChartSmall from "../DoughnutChartSmall";
import CircularSkeletonLoader from "../SkeletonLoaders/CircularSkeletonLoader";

const PowerStreaksCard = () => {
  const { data, isLoading, isError } = useGetUserStreaks();

  if (isError) return null;

  return (
    <div className="col-lg-12 col-xl-8">
      <div
        className="journal-card metric-card dash-circle-content"
        style={{ height: "100%" }}
      >
        <h3 className="h6 mb-3">Power Streaks</h3>
        {isLoading ? (
          <div className="d-flex flex-wrap gap-3">
            <CircularSkeletonLoader size="72px" count={4} />
          </div>
        ) : (
          <div className="streaks-grid">
            {Object.keys(data || {}).length > 0
              ? Object.entries(data).map(([key, value]) => (
                  <div className="streak-item" key={key}>
                    <div className="streak-circle">
                      <DoughnutChartSmall
                        dataset={[
                          value.obtained,
                          value.total > 0 ? value.total - value.obtained : 1,
                        ]}
                      />
                      <span className="streak-value">{value.obtained}</span>
                    </div>
                    <div className="streak-label">
                      {key
                        .split("_")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                    </div>
                    <div className="streak-sublabel">
                      {key === "war_maps" ? "(Weekly)" : "(Daily)"}
                    </div>
                  </div>
                ))
              : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default PowerStreaksCard;
